// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Z9Yi","inputWrap":"Table_inputWrap__XCQ1y","col":"Table_col__1Azv4","bmiTooltip":"Table_bmiTooltip__32bCi"};